export default __webpack_public_path__ + "static/media/img_14.286c0946.jpg";